<template>
  <v-dialog
    v-model="_active"
    :fullscreen="showMobileView"
    :width="showMobileView ? '' : '600'"
    @click:outside="_setActive(false)"
  >
    <v-card>
      <v-card color="primary" tile>
        <v-card-title class="py-0 white--text" color="primary">
          <v-container>
            <v-row>
              <v-spacer cols="2" />
              <v-col cols="8" class="pb-0">
                <v-card-text
                  class="text-center text-subtitle-1 font-weight-medium pb-0"
                >
                  {{ `${_details.setOne[2].value} REPORT` }}
                </v-card-text>
              </v-col>
              <v-col cols="2" class="pb-0 pt-5">
                <v-btn color="white" text @click="_setActive(false)">
                  <v-icon xl>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-title>
      </v-card>

      <div class="py-4">
        <div v-for="(data, i) in _details.setOne" :key="i">
          <div class="py-1 px-3">
            <v-row>
              <v-col cols="6" class="py-0">
                <v-card-text class="py-0">
                  {{ data.title }}
                </v-card-text>
              </v-col>
              <v-col cols="6" class="py-0">
                <v-card-text
                  class="text-subtitle-1 font-weight-medium text-right py-0 pl-0"
                >
                  {{ data.value }}
                </v-card-text>
              </v-col>
            </v-row>
          </div>
        </div>
        <v-divider class="my-4 mx-7" />
        <div v-for="(data, j) in _details.setTwo" :key="j">
          <div class="py-1 px-3">
            <v-row>
              <v-col cols="6" class="py-0">
                <v-card-text class="py-0">
                  {{ data.title }}
                </v-card-text>
              </v-col>
              <v-col cols="6" class="py-0">
                <v-card-text
                  class="text-subtitle-1 font-weight-medium text-right py-0 pl-0"
                >
                  {{ data.value }}
                </v-card-text>
              </v-col>
            </v-row>
          </div>
        </div>
        <v-divider class="my-4 mx-7" />
        <div v-for="(data, k) in _details.setThree" :key="k">
          <div class="py-1 px-3">
            <v-row>
              <v-col cols="6" class="py-0">
                <v-card-text class="py-0 pr-0">
                  {{ data.title }}
                </v-card-text>
              </v-col>
              <v-col cols="6" class="py-0">
                <v-card-text
                  class="text-subtitle-1 font-weight-medium text-right py-0 pl-0 text-truncate"
                >
                  {{ data.value }}
                </v-card-text>
              </v-col>
            </v-row>
          </div>
        </div>
        <v-divider class="my-4 mx-7" />
        <div class=" d-flex justify-space-between py-1 px-3">
          <v-card-text class="py-0 pr-0">
            Export App Usage Data
          </v-card-text>
          <v-btn
            color="secondary"
            class="white--text mr-3"
            height="30"
            width="90"
          >
            <v-icon small>
              mdi-download
            </v-icon>
            Export
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import MobileView from '@/mixins/MobileView';

export default {
  mixins: [MobileView],
  methods: {
    ...mapMutations({
      _setActive: 'reportDetails/setRentalDetails',
    }),
  },
  computed: {
    ...mapGetters({
      // _active: "reportDetails/getRentalDetails",
      // _details: "reportDetails/getRentalData"
    }),
  },
};
</script>
